function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.184 9.28h1.127c.473 0 .982.233.961.819-.018.526-.336.843-.961.843H1.184V9.28zM0 8.3v5.658h1.184v-2.054h1.313c1.065 0 1.814-.753 1.814-1.772 0-1.064-.806-1.83-1.814-1.83L0 8.3zM6.329 9.28h.876c1.148 0 1.574.747 1.578 1.79.001 1.062-.473 1.925-1.474 1.925h-.98V9.28zM5.178 8.3v5.658h2.369c1.622 0 2.47-1.427 2.445-2.888C9.964 9.478 8.872 8.3 7.37 8.3H5.178zM10.97 8.301v5.658h1.184v-2.386h2.488v-.998h-2.487V9.29H15v-.988h-4.03z",
  fill: "currentColor",
  fillOpacity: 0.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.433 0L.003 5.101V7.5h1.086V5.85h4.928V2.203H4.929v2.557H1.737l3.192-3.673h8.98V7.5h1.087V0H4.433zM.003 14.79v2.784l14.993.015V12.87h-1.088V16.5l-12.82-.012V14.79H.004z",
  fill: "currentColor",
  fillOpacity: 0.5
});

function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPdf;